import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  lastUpdate: {
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  paragraph: {
    marginBottom: theme.spacing(2),
    textAlign: 'justify',
    lineHeight: 1.8,
  },
  list: {
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    '& li': {
      marginBottom: theme.spacing(1),
      lineHeight: 1.6,
    },
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: theme.spacing(2),
    '& th, & td': {
      padding: theme.spacing(1),
      textAlign: 'left',
      border: '1px solid #ddd',
    },
    '& th': {
      backgroundColor: '#f5f5f5',
    },
  },
}));

interface LegalPageLayoutProps {
  title: string;
  lastUpdate: string;
  children: React.ReactNode;
}

export const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, lastUpdate, children }) => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h4" component="h1" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body2" className={classes.lastUpdate}>
          Ultimo aggiornamento: {lastUpdate}
        </Typography>
        {children}
      </Paper>
    </Container>
  );
};

export const useLegalStyles = () => useStyles();
